export default class UserAccessRestrictions {
    constructor(userId) {
        this.userId = userId;
        this.hourlyRestriction = null;
        this.timeRangeRestrictions = [];
    }
}